import React from "react";
import HomepageComponent from "./components/pages/homepage";

const Homepage = () => {
  return <HomepageComponent />;
};

export default Homepage;
